module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents"
  }, [_c('p', {
    staticClass: "contentsHead"
  }, [_c('a', {
    attrs: {
      "id": "TOC1"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "TOC1"
    }
  }), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "id": "TOC1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/e9781338184655_title001#tp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ded001#ded01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781338184655_ch001#ch1"
    }
  }, [_vm._v("Chapter 1: Triple Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781338184655_ch002#ch2"
    }
  }, [_vm._v("Chapter 2: The Offer")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ch003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Emergency!")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ch004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Quartered")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ch005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: The Chase")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ch006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Yummy Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ch007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: No Substitute")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ch008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Back to the Lab")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ch009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Shot Heard ’Round the Town")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ch010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Van of Doom")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ch011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: False Information")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ch012#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: This Means War!")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ch013#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Carob Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_bm001#bm1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sneak Peek")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_bm007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also Available")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', {
    attrs: {
      "href": "#/e9781338184655_copy001#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3af58c41","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781338184655_toc001.vue
// module id = 63
// module chunks = 0